import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: '0px 0px 0px 16px !important',
        background: '#4c4fa6 !important',
        color: 'white !important',
        padding: '6px 40px !important',
        // fontFamily: 'Rubik' !important',
        textTransform: 'none !important'
    }
}))

export default function ConfirmDialog({ text, showDialogBox, callClose, callConfirmation }) {
    const classes = useStyles();
    const handleClose = () => {
        callClose();
    };
    const handleOk = () => {
        callConfirmation();
    };

    return (
        <>
            <Dialog
                open={showDialogBox}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                <DialogTitle style={{ fontFamily: 'Rubik' }} id="alert-dialog-title">
                    Please confirm
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ fontFamily: 'Rubik' }}>
                        {text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined" color="primary" size="small" className={classes.button}>
                        Cancel
                    </Button>
                    <Button onClick={handleOk} variant="outlined" color="primary" size="small" className="btnBluepop" autoFocus>
                        Ok
                    </Button>
                    {/* <Button onClick={handleOk} variant="outlined" color="primary" style={{ fontFamily: 'Rubik' }}>
                        Ok
                    </Button>
                    <Button onClick={handleClose} variant="outlined" color="primary" autoFocus style={{ fontFamily: 'Rubik' }}>
                        Cancel
                    </Button> */}
                </DialogActions>
            </Dialog>
        </>
    );
}
